module.exports = {"DASHBOARD_TITLE":"Tableau de bord","DASHBOARD_MEMBER_STATISTIC":"Membres de l'équipe","DASHBOARD_MEMBER_TABLE_COL_NAME":"Nom","DASHBOARD_MEMBER_TABLE_COL_TICKET_OPENED":"Nb de tickets en cours","DASHBOARD_MEMBER_TABLE_COL_TICKET_TOTAL":"Nb total de tickets","DASHBOARD_MEMBER_TABLE_COL_RESOLUTION":"Temps de résolution moyen","DASHBOARD_MEMBER_TABLE_COL_TICKET_RESOLVED":"Nb de tickets résolus","DASHBOARD_CONTRACTOR_STATISTIC":"Affectation par techniciens","DASHBOARD_TABLE_COL_BLOCK_NAME":"Immeuble"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/dashboard/dashboard.fr.json
// module id = ipv0
// module chunks = 0